module.exports = __webpack_public_path__ + "static/media/Bortoli.d93a30dd.png";